var map = {
	"./1_1.svg": "kLGA",
	"./1_2.svg": "DqhF",
	"./2_1.svg": "29LR",
	"./2_2.svg": "oQe1",
	"./3_1.svg": "H07l",
	"./3_2.svg": "bz0f",
	"./4_1.svg": "ILNh",
	"./4_2.svg": "+omC",
	"./addImages0.svg": "hNJV",
	"./addImages1.svg": "kpK6",
	"./down0.svg": "LiEb",
	"./down1.svg": "iP5b",
	"./drag0.svg": "7+qX",
	"./drag1.svg": "IJXh",
	"./operation_drag.svg": "sLAb",
	"./operation_drag1.svg": "aSP8",
	"./option_delete.svg": "iaj7",
	"./select.svg": "hwRw",
	"./seniorEditor0.svg": "OJxR",
	"./seniorEditor1.svg": "pOkq",
	"./title_editor_icon.svg": "dsrN",
	"./up0.svg": "c/H0",
	"./up1.svg": "UfIw",
	"./填空符.svg": "D4SJ",
	"./添加选项.svg": "Upyx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f/nW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire ^\.\/.*\.svg$
// module id = f/nW
// module chunks = 0